module.exports = __webpack_public_path__ + "img/curriculum-development.41dd8dbf.png";